import { $Q, $Qll } from './query-selector'

/**
 * Update the width of bar progress
 * @param {DOM element} input - input hidde with data
 */
export const barProgress = (input, price) => {
  const successMessage = $Q("#bar_success_message").value;
  const standarMessage = $Q("#bar_standar_message").innerHTML;
  const barMessage = $Q("#bar_message");
  const totalPrice = parseFloat(price) / 100
  const limitPrice = input.dataset.limit;
  const progress = $Q(".bar-progress");

  // eslint-disable-next-line no-mixed-operators
  const barWidth = totalPrice / limitPrice * 100;
  const remainingPrice = limitPrice - totalPrice;

  if (barWidth > 100) {
    progress.style.width = "100%";
    barMessage.innerText = successMessage;
  } else {
    progress.style.width = `${barWidth}%`;
    barMessage.innerHTML = standarMessage;
    const limitPriceElement = $Qll(".bar_limit_price");

    limitPriceElement.forEach((element) => {
      // eslint-disable-next-line no-param-reassign
      element.innerText = `${remainingPrice.toFixed(2).toString()}€`;
    });
  }
}
